import React from "react";

import "../styles/Shop.css";
import ProductCardTest from "../components/ProductCardTest";
import { useLoaderData } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

export async function loader() {
  const response = await fetch(`${apiUrl}/ct/products`, {
    headers: { "X-App-Secret": process.env.REACT_APP_APP_SECRET },
  });

  if (!response.ok) {
    throw new Response(
      JSON.stringify({ message: "Could not fetch inventory." }),
      { status: response.status }
    );
  }

  const inventory = await response.json();
  return inventory;
}

export default function Shop() {
  const swimmingTrunks = useLoaderData();

  // Hardcoded desktop order
  const desktopOrder = ["CT0003", "CT0005", "CT0002", "CT0001", "CT0004"];

  // Detect if the device is desktop (e.g., using window.innerWidth)
  const isDesktop = window.innerWidth > 768;

  // Sort related products based on hardcoded order for desktop
  const orderedTrunks = isDesktop
    ? swimmingTrunks.sort(
        (a, b) =>
          desktopOrder.indexOf(a.product_id) -
          desktopOrder.indexOf(b.product_id)
      )
    : swimmingTrunks;

  return (
    <div className="shop-page-container">
      {/* Breadcrumb navigation */}
      <div className="breadcrumb">
        <span>Mens</span> / <span>Spring 2025</span>
      </div>

      {/* Page title */}
      <h1 className="shop-page-title">Mens Spring 2025</h1>
      <div className="catalogue-container">
        {orderedTrunks.map((product, index) => {
          const isSpecial =
            isDesktop &&
            (index === orderedTrunks.length - 2 ||
              index === orderedTrunks.length - 1);
          return (
            <ProductCardTest
              key={product.product_id}
              product={product}
              className={`product-card ${isSpecial ? "special" : ""}`}
            />
          );
        })}
      </div>
    </div>
  );
}
